import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

// Module-level cache so the live, monthly-refreshed compliance map (served
// from MongoDB via GET /api/export-compliance) is fetched once per page
// load and shared between ExportDestinationPage and the ChatWidget, instead
// of each consumer re-fetching it independently.
let cache = null;
let inflight = null;

export const fetchComplianceMap = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = fetch(`${API}/api/export-compliance`)
      .then((r) => r.json())
      .then((data) => { cache = data; return data; })
      .catch(() => ({}));
  }
  return inflight;
};

// Returns the live compliance doc for a slug, falling back to null (caller
// should fall back to the bundled static copy in pageContent.js) until the
// fetch resolves or if it fails.
export const useLiveCompliance = (slug) => {
  const [compliance, setCompliance] = useState(cache?.[slug] || null);
  useEffect(() => {
    fetchComplianceMap().then((map) => setCompliance(map[slug] || null));
  }, [slug]);
  return compliance;
};
